import { getRgbaColor } from "../shared/utils/color/color";
import { colors } from './color';
export const shadows = {
    soft: `0px 2px 4px 2px ${getRgbaColor(colors.core.slate, 0.05)}`,
    hard: `0px 4px 8px ${getRgbaColor(colors.core.slate, 0.25)}`,
};
